import { useStore } from "vuex";

import { useMutation } from "@tanstack/vue-query";

import applicationsService from "@/services/modules/applications";

import type { IOffer } from "@/models/funders";

export const useToggleOfferSharedMutation = () => {
  const store = useStore();

  return useMutation({
    mutationFn: (data: { offerId: IOffer["id"] }) =>
      applicationsService.toggleShowOffer(data.offerId),
    onSuccess: () => {
      store.dispatch("applications/getOffers");
    },
  });
};
